import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleUpSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChevronTriangleUpSmall"><Path d="M15 13H9L12 9.5L15 13Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleUpSmall;
